var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-newsection',{ref:"newsection",attrs:{"rule_json":_vm.ruleJson,"prefill_data":_vm.editedData},on:{"outputJson":_vm.getOutput}}),_c('button',{on:{"click":_vm.getQury}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }